import { PackageHistoryDto } from '../../../api/models/PackageDto';

export interface ComparedField {
    key: keyof PackageHistoryDto;
    label: string;
    isJson: boolean;
}

export const COMPARED_FIELDS: ComparedField[] = [
    { key: 'name', label: 'Name', isJson: false },
    { key: 'description', label: 'Description', isJson: false },
    { key: 'moreInfo', label: 'More Info (HTML)', isJson: false },
    { key: 'configurationStrategy', label: 'Configuration Strategy (JSON)', isJson: true },
    { key: 'cleanupConfigurationStrategy', label: 'Cleanup Configuration Strategy (JSON)', isJson: true },
    { key: 'customFields', label: 'Custom Fields (JSON)', isJson: true },
];

export const formatFieldValue = (version: PackageHistoryDto, field: ComparedField): string => {
    const value = version[field.key];
    if (value == null) return '';
    if (!field.isJson) return String(value);
    try {
        return JSON.stringify(JSON.parse(String(value)), null, 2);
    } catch {
        return String(value);
    }
};

export const checkForDifferences = (versions: PackageHistoryDto[]): boolean => {
    if (versions.length !== 2) return true;

    return COMPARED_FIELDS.some(field => {
        const v1 = formatFieldValue(versions[0], field);
        const v2 = formatFieldValue(versions[1], field);
        return v1 !== v2;
    });
};

export const getSelectedVersionsData = (selectedVersions: string[], history: PackageHistoryDto[]): PackageHistoryDto[] => {
    const versions = selectedVersions.map(validFrom => {
        const found = history.find(h => h.validFrom === validFrom);
        return found;
    }).filter(Boolean) as PackageHistoryDto[];
    
    // Ensure consistent ordering - older version first, newer version second
    return versions.sort((a, b) => new Date(a.validFrom).getTime() - new Date(b.validFrom).getTime());
};